import Head from 'next/head'
import Layout from '../components/Layout'
import useAuth, {  } from '../lib/useAuth'
import styles from './account-information.module.scss'

import { getAuth, buildClerkProps } from '@clerk/nextjs/server'
import { GetServerSideProps } from 'next'


import AuthContent from '../components/AuthContent'
import { MenuId } from '../components/Header'
import ContentPanes, { ContentPaneTypes } from '../components/ContentPanes'
import AccountDescription from '../components/AccountDescription'


export default function MyAccount() {


    return (
        <Layout menuId={MenuId.account}>
            <Head>
                <title>My account</title>
                <meta name="robots" content="noindex"/>
            </Head>
            <AuthContent>
            <div className = {styles.mainContent}>
            <h1>My account</h1>
            <div className = {styles.topLine}>
                <div className = {styles.subscriptionInformation}>
                <AccountDescription/>
                </div>
                </div>
            </div>
            <ContentPanes contentPanes={[ContentPaneTypes.onlineSessions, ContentPaneTypes.playlists, ContentPaneTypes.videoSearch, ContentPaneTypes.imageSearch, ContentPaneTypes.threeDLibrary, ContentPaneTypes.discounts, ContentPaneTypes.accountSettings, ContentPaneTypes.userImages]}/>

            </AuthContent>
        </Layout>
    )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { userId } = getAuth(ctx.req)
  return { props: { ...buildClerkProps(ctx.req) } }
}

